import Session from './session'

export default class WorkAPI {

  static get PREFIX () {
    return Session.HOST + '/api/work'
  }

  /**
  * 勤怠取得
  */
  static getWork (targetDate) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/' + targetDate)
  }

  /**
  * 勤怠編集取得
  */
  static getWorkEdit (targetDate, params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/edit/' + targetDate, {params: params})
  }

  /**
  * 勤怠編集
  */
  static edit (body) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/edit', body)
  }

  /**
  * 勤務表取得
  */
  static getWorkTimetable (params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/timetable', { params: params })
  }

  /**
  * 月間サマリ取得
  */
  static getMonthlySummary (params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/monthlySummary', { params: params })
  }

  /**
  * 年間サマリ取得
  */
  static getAnnuallySummary (params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/annuallySummary', { params: params })
  }

  /**
  * 出勤
  */
  static clockIn (userId, targetDate) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/clockIn/' + userId + '/' + targetDate)
  }

  /**
  * 退勤
  */
  static clockOut (work) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/clockOut', work)
  }

  /**
  * 早退確認
  */
  static isLeaveEarly (userId, targetDate) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/isLeaveEarly/' + userId + '/' + targetDate)
  }

  /**
  * 早出登録
  */
  static postEarlyShift (body) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/earlyShift', body)
  }

  /**
  * 勤務形態登録
  */
   static postWorkStyle  (body) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/workStyle', body)
  }

  /**
  * 年一覧取得
  */
  static getYearList () {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/yearList')
  }

  /**
  * ステータス更新
  */
  static updateStatus (status, year, month, userId) {
    const s = new Session()
    let url = this.PREFIX + '/status-update/' + status + '/' + year + '/' + month
    // ユーザIDの指定があればURLに追加する
    if (userId != null){
      url = url + '?userId=' + userId
    }
    return s.ins.patch(url)
  }

  /**
   * 勤怠削除
   */
  static delete (userId, date) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + '/delete/' + userId + '/' + date)
  }

  /**
   * 添付ファイル削除
   */
  static deleteFile (year, month, userId) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + '/timetable/upload/' + year + '/' + month + '/' + userId)
  }

  /**
   * 勤務表アップロード
   */
  static upload (year, month, userId, data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/timetable/upload/' + year + '/' + month + '/' + userId, data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  }

  /**
   * 添付存在確認
   */
  static isExistsUpload (year, month, userId) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/timetable/upload/' + year + '/' + month + '/' + userId + '/is-exists')
  }

  /**
   * 添付存在取得（部署単位）
   */
  static isExistsUploadByDepartment (year, month, departmentId) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/timetable/upload/' + year + '/' + month + '/is-exists' + '?departmentId=' + departmentId)
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/api/work-api.js